import service from '@/utils/request'
import { serviceGo } from '@/utils/request'

export interface ResourceMapping {
  id: number
  game_id: number
  display_name: string
  oss_filename: string
  file_type: 'image' | 'music' | 'portrait' | 'cover' | 'costume' | 'shop_item'
  oss_url: string
  file_size: number
}

export function getResources(gameId: number, fileType?: string) {
  const params: Record<string, unknown> = { game_id: gameId }
  if (fileType) params.file_type = fileType
  return serviceGo.get('/api_v2/resources', { params })
}

/** 上传文件到阿里云 OSS（通过 Go 后端） */
export function uploadResource(formData: FormData) {
  return serviceGo.post('/api_v2/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/** 删除资源 */
export function deleteResource(id: number) {
  return serviceGo.delete(`/api_v2/resources/delete/${id}`)
}

/** 上传文件到阿里云 OSS（通过 Go 后端），支持进度回调 */
export function uploadResourceWithProgress(
  formData: FormData,
  onProgress?: (percent: number) => void
) {
  return serviceGo.post('/api_v2/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e: any) => {
      if (onProgress && e.total) {
        onProgress(Math.round((e.loaded * 100) / e.total))
      }
    }
  })
}
